var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoNoArchived(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 0a4 4 0 0 1 4 4v14a4 4 0 0 1-4 4v37.707C60 62.078 58.21 64 56 64H8c-2.21 0-4-1.922-4-4.293V22a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h56zm-2 22H6v37.838c0 1.14.816 2.074 1.85 2.156L8 62h48c1.054 0 1.918-.882 1.995-2l.005-.162V22zM40 38a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H25a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h15zm0 2H25v4h15v-4zM60 2H4a2 2 0 0 0-1.995 1.85L2 4v14a2 2 0 0 0 1.85 1.995L4 20h56a2 2 0 0 0 1.995-1.85L62 18V4a2 2 0 0 0-1.85-1.995L60 2z",
    fill: "#888FA9",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNoArchived);
export default __webpack_public_path__ + "static/media/ico-no-archived.a7e5ef4ad55b16e10f4888b04817c6e3.svg";
export { ForwardRef as ReactComponent };